export const mockOfferData = {
    sreCvm: {
        tipoRito: "11/03/2024",
        dataRequerimento: "11/03/2024",
        distribuicaoLinkSre: "web.cvm.gov.br/sre...",
        distribuicaoLinkSreHref: "https://web.cvm.gov.br/sre",
        tipoMercado: "Primária",
        regimeDistribuicao: "Melhores esforços",
    },

    dataReserva: {
        inicio: "11/03/2024",
        encerramento: "11/03/2024",
    },

    dataOferta: {
        inicio: "11/03/2024",
        encerramentoMaximo: "11/03/2024",
        encerramentoEfetivo: "11/03/2024",
    },

    bookbuilding: {
        tem: "Sim",
        data: "11/03/2024",
        remuneracao: "1234567890123456790",
    },

    publicoAlvoDatasLockup: {
        columns: ["IG", "IP", "IQ"],
        rows: [
            {
                label: "IG",
                values: {
                    ig: "11/03/2024",
                    ip: "11/03/2024",
                    iq: "11/03/2024",
                },
            },
            {
                label: "IP",
                values: {
                    ig: "11/03/2024",
                    ip: "11/03/2024",
                    iq: "11/03/2024",
                },
            },
            {
                label: "IQ",
                values: {
                    ig: "11/03/2024",
                    ip: "11/03/2024",
                    iq: "11/03/2024",
                },
            },
        ],
    },

    publicoAlvoInvestidorGeral: {
        inicial: "Sim",
        final: "Sim",
    },

    publicoAlvoInvestidorQualificado: {
        inicial: "Sim",
        final: "Sim",
    },

    publicoAlvoInvestidorProfissional: {
        inicial: "Sim",
        final: "Sim",
    },

    coordenadores: [
        {
            title: "Coordenador líder",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 1",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 2",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 3",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 4",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 5",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 6",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
        {
            title: "Coordenador 7",
            value: "Itaú Unibanco S.A.",
            optionalText: "60.701.190/0001-04",
        },
    ],
}